import API from "@/lib/api";

// Public app config (tier card designs + font sizes). Fetched once and cached
// for the session so multiple components can share it without extra requests.
let _cache = null;
let _promise = null;

export async function fetchAppConfig() {
  if (_cache) return _cache;
  if (!_promise) {
    _promise = API.get("/app-config")
      .then((r) => { _cache = r.data || { tier_design: {}, fonts: {} }; return _cache; })
      .catch(() => ({ tier_design: {}, fonts: {} }));
  }
  return _promise;
}

export function clearAppConfigCache() { _cache = null; _promise = null; }
